/* eslint-disable react/prop-types */
import { forwardRef } from "react";
import { Dialog, DialogContent, DialogTitle, Slide, IconButton } from "@material-ui/core";

import CancelIcon from "@material-ui/icons/Cancel";
import DescriptionIcon from "@material-ui/icons/Description";
import PdfViewRender from "./pdfViewerOption/PdfViewerOption";
import initCapitalize from "../../../utils/commonFunctions/initCapitalize";
import EventIcon from "@material-ui/icons/Event";
import { dateTimeZoneConverter } from "../../../utils/commonFunctions/date";

import "./customPdfViewWithTitleDialog.css";

const Transition = forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const CustomPdfViewWithTitleDialog = ({ dialogProps, handleClose, pdfFile, eventName, eventDate }) => {
	const { openDialog } = dialogProps;

	return (
		<div>
			<Dialog
				style={{ zIndex: 5000, overflowY: "hidden" }}
				open={openDialog}
				onClose={handleClose}
				TransitionComponent={Transition}
				keepMounted
				aria-labelledby="alert-dialog-slide-title"
				aria-describedby="alert-dialog-slide-description"
				maxWidth="lg"
			>
				<DialogTitle>
					<div
						className="dialog-title-container"
						style={{
							padding: "10px",
							justifyContent: "space-between",
							display: "flex",
							alignItems: "center"
						}}
					>
						<div className="wrap-container">
							<div className="event-name-container">
								<DescriptionIcon className="event-name-icon" />
								<span className="event-name">{eventName ? initCapitalize(eventName) : ""}</span>
							</div>
							{!eventDate ? (
								<div className="dialog-title-date-container">
									<EventIcon className="dialog-title-date-icon" />
									<span id="dialog-title-date">
										{eventDate ? dateTimeZoneConverter(eventDate) : ""}
									</span>
								</div>
							) : null}
						</div>

						<span>
							<IconButton aria-label="close" onClick={handleClose}>
								<CancelIcon fontSize="medium" />
							</IconButton>
						</span>
					</div>
				</DialogTitle>
				<DialogContent className="dialog-content">
					<PdfViewRender pdfFile={pdfFile} />
				</DialogContent>
			</Dialog>
		</div>
	);
};

export default CustomPdfViewWithTitleDialog;
